import React from 'react';

import {Provider as ReduxProvider} from 'react-redux';

import {store} from '../store';

const withRedux =
    <P extends {}>(Component: React.FC<P>) =>
    (props: P) =>
        (
            <ReduxProvider store={store}>
                <Component {...props} />
            </ReduxProvider>
        );

export {withRedux};
